import React, { MutableRefObject, useRef } from 'react';
import cn from 'classnames';
import { useClient, useViewParagraphCount } from 'src/hooks';
import { CONTENT_SUB_TYPE } from 'src/constants';
import { RouterLink } from 'src/components/links';
import BodyBlock from './BodyBlock';
import LiveBodyBlock from './LiveBodyBlock';
import styles from '../style.module.scss';
export interface ITextProps {
    type: string;
    content: string;
    subType?: string;
    index: number;
    contentId?: number;
}

const hasSubType = (typeStr = '', type: string) => {
    return typeStr.split(' ').includes(type);
};

export default React.memo(function ContentText(props: ITextProps) {
    const { content, subType = '', type, index, contentId } = props;
    const { isClient } = useClient();

    const eleRef: MutableRefObject<HTMLImageElement | null> =
        useRef<HTMLImageElement>(null);
    useViewParagraphCount({ index, eleRef, type, contentId });

    if (hasSubType(subType, CONTENT_SUB_TYPE.BODY_BLOCK)) {
        return <BodyBlock {...(props as any)} />;
    } else if (hasSubType(subType, CONTENT_SUB_TYPE.LIVE_BODY_BLOCK)) {
        return <LiveBodyBlock {...(props as any)} />;
    }
    
    function splitByTagLink(html: string) {
        const regex = /<a\s+class="tag-link"[^>]*>[\s\S]*?<\/a>/;

        const match = html.match(regex);

        if (!match) {
            return { before: html, aTag: '', after: '' };
        }

        const aTag = match[0];
        const index = match.index || 0;

        return {
            before: html.slice(0, index),
            aTag,
            after: html.slice(index + aTag.length),
        };
    }

    const { before, aTag, after } = splitByTagLink(content);
    if (aTag && isClient) {
        return (
            <p ref={eleRef}>
                <span dangerouslySetInnerHTML={{ __html: before }} />
                {aTag && <TagLink content={aTag} />}
                <span dangerouslySetInnerHTML={{ __html: after }} />
            </p>
        );
    }

    return (
        <p
            ref={eleRef}
            className={cn(styles[type], styles[subType])}
            dangerouslySetInnerHTML={{ __html: content }}
        />
    );
});

const TagLink = ({ content }: { content: string }) => {
    const regex =
        /<a\s+class="tag-link"[^>]*href="([^"]+)"[^>]*>([\s\S]*?)<\/a>/;
    const match = content.match(regex);

    if (!match) {
        return null;
    }

    const href = match[1];
    const text = match[2];

    return (
        <RouterLink className="tag-link" to={href}>
            {text}
        </RouterLink>
    );
};
